
const gundogduQuestionStandardTypes = [
        {
        key: "cefr",
        label: "CEFR",
      },
  ];

export default gundogduQuestionStandardTypes;